import { createContext, useContext, useState, useEffect } from 'react';
import { instanceApi } from '../services/api';

// Default labels (CII mode) — used before fetch completes and as fallback
const DEFAULT_LABELS = {
  isCII: true,
  entityName: 'OES',
  entityNameFull: 'Operator of Essential Services',
  entityNamePlural: 'OES',
  entityNamePluralFull: 'Operators of Essential Services',
  platformTitle: 'Critical Information Infrastructure',
  platformSubtitle: 'Security Management Platform',
  headerTitle: 'CII Security Management',
  headerSubtitle: 'Critical Infrastructure Protection',
  brandName: 'LAC4',
  showSectorDeps: true,
  reportTitle: 'CII Assessment Report',
  reportFilenamePrefix: 'CII',
  loginLogo: '/LAC4_white.svg',
  navbarLogo: '/LAC4.png',
};

const LabelsContext = createContext(DEFAULT_LABELS);

export default function LabelsProvider({ children }) {
  const [labels, setLabels] = useState(DEFAULT_LABELS);

  useEffect(() => {
    instanceApi.getLabels()
      .then(r => {
        if (r.data) {
          const merged = { ...DEFAULT_LABELS, ...r.data };
          setLabels(merged);
          document.title = merged.headerTitle || merged.brandName || 'Security Management Platform';
        }
      })
      .catch(() => {
        // Keep defaults on error
      });
  }, []);

  return (
    <LabelsContext.Provider value={labels}>
      {children}
    </LabelsContext.Provider>
  );
}

export function useLabels() {
  return useContext(LabelsContext);
}
